<template>
  <v-form
  class="pa-6"
    ref="form"
    v-model="valid"
    lazy-validation>

    <h3 class="text-left mb-1 text-primary">Sign Server</h3>
    <p class="text-caption mb-4">Autorizá y firmá con un certificado de Alison Server.</p>

    <div class="d-flex ga-2 mb-6">
      <v-btn
          size="small"
          :disabled="!valid"
          color="primary"
          @click="authorize">
        Authorize >>
      </v-btn>
    </div>
    <v-row>
      <v-col md="6">
        <v-select
            v-model="certificateSelected"
            :items="certificateList"
            item-title="id"
            item-value="id"
            label="Select Certificate"
            @update:modelValue="changeCertificate"
        ></v-select>
        <v-row>
          <v-col>
            <v-text-field v-if="infoCredential?.PIN?.presence == 'true'"
                v-model="PIN"
                label="PIN"
            ></v-text-field>
            <v-text-field v-if="infoCredential?.OTP?.presence == 'true'"
                v-model="OTP"
                label="OTP"
            ></v-text-field>
            <v-text-field v-if="infoCredential?.EMAIL?.presence == 'true'"
                v-model="EMAIL"
                label="EMAIL"
            ></v-text-field>
            <v-text-field v-if="infoCredential?.SMS?.presence == 'true'"
                v-model="SMS"
                label="SMS"
            ></v-text-field>
            <v-text-field
                v-model="text"
                label="DataToSign"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-model="certificate"
              label="Certificate"
          ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-divider class="my-6"></v-divider>

    <v-row>
      <v-col cols="12">
        <vue-json-pretty :rootPath="'res'" :data=this.response> </vue-json-pretty>
      </v-col>
    </v-row>

    <v-divider class="my-6"></v-divider>

    <div class="d-flex ga-2 mb-6">
      <v-btn
          size="small"
          :disabled="response == null"
          color="primary"
          @click="sign">
        Sign >>
      </v-btn>
    </div>
    <v-row>
      <v-col md="6">
        <v-select
          v-model="format"
          :items="formatItems"
          label="Format"
        ></v-select>
        <v-autocomplete
          v-model="signAlgorithm"
          :items="signAlgorithmOPTIONS"
          label="Sign Algorithm"
        ></v-autocomplete>
        <v-autocomplete
          v-model="hashAlgorithm"
          :items="hashAlgorithmOPTIONS"
          label="Hash Algorithm"
        ></v-autocomplete>
      </v-col>
    </v-row>

    <v-divider class="my-6"></v-divider>

    <v-row>
      <v-col cols="12">
        <vue-json-pretty :rootPath="'res'" :data=this.responseSign> </vue-json-pretty>
      </v-col>
    </v-row>

  </v-form>
</template>
<script>

import { mapMutations } from 'vuex'
import alisonJS from  '@/services/alison_js.js'
import alisonServer from  '../services/alisonServer.js';
import VueJsonPretty from 'vue-json-pretty';

  export default  {
    props: ['serverConfig'],
    components: {
      VueJsonPretty
    },
    data: () => ({
      text: 'sTOgwOm+474gFj0q0x1iSNspKqbcse4IeiqlDg/HWuI=',
      SADToken: '',
      PIN: '',
      OTP: '',
      SMS: '',
      EMAIL: '',
      infoCredential: null,
      dataToSignB64: null,
      certificate: null,
      certificateSelected: '',
      certificateList: [],
      signature: null,
      signAlgorithm: "1.2.840.113549.1.1.1",
      hashAlgorithm: "2.16.840.1.101.3.4.2.1",
      valid: true,
      format: null,
      params: null,
      formatItems: [],
      keystoresOPTIONS: [],
      signAlgorithmOPTIONS: ["1.2.840.113549.1.1.1"],
      hashAlgorithmOPTIONS: ["2.16.840.1.101.3.4.2.1"],
      profileOPTIONS: [],
      requestPayload: '{}',
      response: null,
      responseSign: null,
    }),
    async mounted(){
      this.formatItems = Object.values(alisonJS.getServerSignFormats())
      const credentials = await alisonServer.listCredentials();
      this.certificateList = credentials.map(c => ({ id: c }))
      console.log(credentials);
    },
    watch: {
      infoCredential(value) {
        console.log(value, "changed");
      }
    },
    methods: {
      ...mapMutations({
        setSnack: 'setSnack',
        setColor: 'setColor'
      }),
      async authorize() {
        const sadToken = await alisonServer.authorize({
          credentialId: this.certificate,
          numSignatures: 1,
          hash: [this.text],
          PIN: this.PIN != '' ? this.PIN : null,
          OTP: this.OTP != '' ? this.OTP : null,
          SMS: this.SMS != '' ? this.SMS : null,
          EMAIL: this.EMAIL != '' ? this.EMAIL : null,
        });
        this.response = sadToken
        this.SADToken = sadToken.SAD
      },
      async changeCertificate(cert){
        const info = await alisonServer.certificateInfo(cert)
        this.infoCredential = info
        this.certificate = cert
      },
      async sign() {
        const result = await alisonServer.signHash({
          credentialId: this.certificate,
          SAD: this.SADToken,
          hash: [this.text],
          hashAlgo: this.hashAlgorithm,
          signAlgo: this.signAlgorithm,
          signFormat: this.format,

        })
        this.responseSign = result;
        this.signature = JSON.stringify(result,null, "\t");
      },
    },
  }
</script>
